// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f69f8b3b","239":"c58bc84f","453":"3e5c68c2","455":"29866358"}[chunkId] + ".chunk.js";
};